import type { CaptureContext } from '@sentry/core';
import * as Sentry from '@sentry/react';

import { ENV, isSentryEnabled } from '../Environment';
import { initOptions } from './common';

const debug = require('debug')('tca:kit:sentry:web');

const HealthMonitor = {
  init: (product: string): void => {
    if (!isSentryEnabled) {
      return;
    }

    Sentry.init({
      ...initOptions(product),
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: ENV === 'prod' ? 0.01 : 1.0,
      beforeSend: function (event, hint) {
        debug(`beforeSend:exception:${event.exception?.values?.[0]?.value}`);

        return event;
      },
    });
  },
  logError: (error: unknown, context?: CaptureContext): void => {
    if (!isSentryEnabled) {
      return;
    }

    Sentry.captureException(error, context);
  },
  setTag: (key: string, value: string): void => {
    if (!isSentryEnabled) {
      return;
    }

    Sentry.setTag(key, value);
  },
  testCrash: (): void => {
    if (!isSentryEnabled) {
      return;
    }

    // no-op for web
  },
};

export default HealthMonitor;
